jQuery(document).ready(function($){
	$(window).on('scroll', function(){
			if ($(window).scrollTop() > 30){
		$('body').addClass('float_active');
			}else {
		$('body').removeClass('float_active');
			}
	});

	setInterval(()=>{
		if($('body').hasClass('cart_open')){
			var header_height = $('#cart_sidebar_header').outerHeight();
			var cart_footer = $('#cart_footer').outerHeight();
			var elementsHeight = header_height + cart_footer;

			$('#cart_body').css('--elementsHeight', elementsHeight + 'px');
		}
	}, 500);
	 
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});
		
	var Shopify = Shopify || {};
	Shopify.money_format = "${{amount}}";

	Shopify.formatMoney = function(cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);
	
		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}
	
		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');
		
			if (isNaN(number) || number == null) { return 0; }
		
			number = (number/100.0).toFixed(precision);
		
			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';
		
			return dollars + cents;
		}
	
		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}
	
		return formatString.replace(placeholderRegex, value);
	};

		//data-click-action
	$(document).on('click', '[data-click-action]', function(event){
		event.preventDefault();

		var element = $(this),
			actions = $(this).data('click-action');

		$.each(actions, function(action, action_params){
			if(action && typeof $.fn[action] === 'function'){
				$.fn[action](action_params, element);
			}else{
				console.log('Action '+ action +' not found');
			}
		});
	});
	
	$.fn.activatePasswordRecover = function(args, form){
		var active = $('#login_page').data('active');
		console.log(active);
		
		switch(active){
		case 'login':
			$('#login_page').attr('data-active', 'recover');
			$('#login_page').data('active', 'recover');
			$('#login_form_wrapper').hide();
			$('#recover_form_wrapper').show();
		break;
		case 'recover':
			$('#login_page').attr('data-active', 'login');
			$('#login_page').data('active', 'login');
			$('#login_form_wrapper').show();
			$('#recover_form_wrapper').hide();
		break;
		}
	};
	
	$(document).on('click', '.suport_view_all', function(event){
		var support_item = $(this).closest('.support_item_content');
		
		if($(this).hasClass('open')){
			$(support_item).find('.extra_list').slideUp();
			$(this).text('Collapse').removeClass('open');
		}else{
			$(support_item).find('.extra_list').slideDown();
			$(this).text('Collapse').addClass('open');
		}
	});
	
	$(document).on('click', '.suport_view_all', function(event){
		var support_item = $(this).closest('.support_item_content');
		
		if($(this).hasClass('open')){
			$(support_item).find('.extra_list').slideUp();
			$(this).text('Collapse').removeClass('open');
		}else{
			$(support_item).find('.extra_list').slideDown();
			$(this).text('Collapse').addClass('open');
		}
	});
	
	//TESTIMONIALS
	const testimonials_slider = new Swiper('.testimonials_slider', {
		loop: true,
		navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		},
	});

	//product_materials_carousel
	const product_materials_carousel = new Swiper('.product_materials_carousel', {
		slidesPerView: 8,
		spaceBetween: 30,
		noSwiping:true,
		allowTouchMove: false,
		shortSwipes:false,
		simulateTouch:false,
		breakpoints: {
			0: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			600: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			800: {
				slidesPerView: 5,
				spaceBetween: 10
			},
			1000: {
				slidesPerView: 8,
				spaceBetween: 30
			},
		},
		navigation: {
			nextEl: '.materials-next',
			prevEl: '.materials-prev',
		},
	});

	//data-account-tab
	$(document).on('click', '[data-account-tab]', function(event){
		var tab = $(this).data('account-tab');

		$('.account_menu_item').removeClass('current');
		$(this).addClass('current');
		
		$('.main_account_content').removeClass('active');
		$('#'+ tab).addClass('active');
	});

	//OPEN CHANGE PASSWORD
	$(document).on('click', '#open_change_password', function(event){
		event.preventDefault();
		$('#change_password_modal').addClass('active');
	});

	//CLOSE CHANGE PASSWORD
	$(document).on('click', '#close_change_password', function(event){
		event.preventDefault();
		$('#change_password_modal').removeClass('active');
	});

	//same_as_billing
	$(document).on('click', '#same_as_billing', function(event){
		if($(this).is(':checked')){
			$('#shipping_address').addClass('d-none').removeClass('d-block');
		}else{
			$('#shipping_address').addClass('d-block').removeClass('d-none');
		}
	});

	//reorder_button
	$(document).on('click', '#reorder_button', function(event){
		event.preventDefault();
		var orderId = $('#order_id').val(),
			now = $.now();
		
		orderId = orderId.replace(/\D/g,'');
		$('#cart_loader').addClass('loading');
	
		$.ajax({
			url: 'https://icepick.co/api/shopify/orders.php?v='+ now +'&order_id='+orderId,
			type: 'get',
			success: (data) =>{
					const obj = JSON.parse(data);
					
					if(obj.status != 'success'){
						if(obj.error){
								alert(obj.error);
								return;
						}else{
								alert('An unexpected error occurred, please verify your data and try again');
								return;
						}
					}
					
					$.each(obj.items, function(index, element) {
						if(element.id === 0 || element.id == null) {
						obj.items.splice(index, 1);
						}
					});
					
					add_data = {
						"items": obj.items
					};
			
					$.post('/cart/add.js', add_data)
				.then((response) => {
					//ADD NOTE TO THE CART
					return $.post('/cart/update.js', {
						note: 'Re-Ordered from order #' + orderId
					});
				})
				.then(() => {
					window.location = '/checkout';
				});
			}
		});
	});

	//MOBILE MENU TRIGGER
	$(document).on('click', '#menu_trigger', function(event){
		if($('body').hasClass('menu_open')){
			$('body').removeClass('menu_open');
			$('#header_mobile_menu_wrapper').slideUp();      
		}else{
			$('body').addClass('menu_open');
			$('#header_mobile_menu_wrapper').slideDown(); 
		}
	});

		/**** STICKERS ADD TO CART ****/
	if($('#sticker_product_form').length > 0){
		//GET SELECTED MATERIAL DATA (BY NAME)
		$.fn.getMaterialData = function(material_name){
			var selected_material = materials_data.filter(function(item){
				return item.name == material_name;         
			});
	
			return selected_material[0];
		}

		//GET PRICE BY FORMULA
		$.fn.getStickerPrice = function(size_total, qty, material_cost, multiplier){
			var price = ((size_total * qty) * material_cost) * multiplier;
			price = currency(price);
			return price;
		}

		//GET PRICES OF PREVIEWS BY QTYs
		$.fn.getPricesPreview = function(){
			var qty = parseInt($('#custom_qty').val()),
				material_name = $('.radio_material:checked').val(),
				material_data = $.fn.getMaterialData(material_name),
				material_cost = material_data.cost,
				size_w = $('#size_w').val(),
				size_h = $('#size_h').val(),
				size_total = size_w * size_h,
				rounded_size = size_total,
				rounded_qty = 50,
				extra_multiplier = $('#extra_multiplier').length > 0 ? parseFloat($('#extra_multiplier').val()) : false;

						if($('#custom_qty_radio').is(':checked')){
					//GET ROUNDED qty
					if(qty >= 1 && qty <= 49){rounded_qty = 25;}
					if(qty >= 50 && qty <= 99){rounded_qty = 50;}
					if(qty >= 100 && qty <= 199){rounded_qty = 100;}
					if(qty >= 200 && qty <= 299){rounded_qty = 200;}
					if(qty >= 300 && qty <= 399){rounded_qty = 300;}
					if(qty >= 500 && qty <= 999){rounded_qty = 500;}
					if(qty >= 1000 && qty <= 1999){rounded_qty = 1000;}
					if(qty >= 2000 && qty <= 2999){rounded_qty = 2000;}
					if(qty >= 3000 && qty <= 4999){rounded_qty = 3000;}
					if(qty >= 5000 && qty <= 9999){rounded_qty = 5000;}
					if(qty >= 10000){rounded_qty = 10000;}
						}else{
							rounded_qty = qty;
						}
			
			//GET ROUNDED SIZE
			if(typeof material_data.multipliers[rounded_qty][size_total] == 'undefined'){
				if(size_total > 0 && size_total < 2.5){rounded_size = 1;}
				if(size_total >= 2.5 && size_total < 8){rounded_size = 4;}
				if(size_total >= 8 && size_total <= 9){rounded_size = 9;}
				if(size_total > 9 && size_total <= 16){rounded_size = 16;}
				if(size_total > 16 && size_total < 100){rounded_size = 25;}
				if(size_total >= 100){rounded_size = 100;}
			}
						
			//CUSTOM QTY PREVIEW PRICE
			var multiplier = material_data.multipliers[rounded_qty][rounded_size],
				current_price = $.fn.getStickerPrice(size_total, qty, material_cost, multiplier);
						
			current_price = extra_multiplier ? current_price * extra_multiplier : current_price;

			current_price = current_price > 0 ? current_price : 10;
			
			$('#custom_qty_price').text(currency(current_price).format());
			$('#final_price').val(currency(current_price)).change();
			$('#final_custom_price').val(currency(current_price)).change();

			//SET PRODUCT PROPERTIES
			$('#properties_material').val(material_name);
			$('#properties_qty').val(qty);
			$('#properties_size').val(size_w+'x'+size_h);
			
			$('[data-qty-price-preview]').each(function(idx, item){
				var item_qty = $(this).data('qty-price-preview'),
					item_multiplier = material_data.multipliers[item_qty][rounded_size],
					preview_price = $.fn.getStickerPrice(size_total, item_qty, material_cost, item_multiplier);

				preview_price = extra_multiplier ? preview_price * extra_multiplier : preview_price;
				$(item).text(currency(preview_price).format());
			});
		}
		$.fn.getPricesPreview();

		$.fn.getFirstPrice = function(){
			var qty = parseInt($('#custom_qty').val()),
					material_name = $('.radio_material:checked').val(),
					material_data = $.fn.getMaterialData(material_name),
					material_cost = material_data.cost,
					size_w = $('#size_w').val(),
					size_h = $('#size_h').val(),
					size_total = size_w * size_h,
					rounded_size = size_total,
					rounded_qty = 50,
					extra_multiplier = $('#extra_multiplier').length > 0 ? parseFloat($('#extra_multiplier').val()) : false;
			
			//GET ROUNDED qty
			if(qty >= 1 && qty <= 49){rounded_qty = 25;}
			if(qty >= 50 && qty <= 99){rounded_qty = 50;}
			if(qty >= 100 && qty <= 199){rounded_qty = 100;}
			if(qty >= 200 && qty <= 299){rounded_qty = 200;}
			if(qty >= 300 && qty <= 399){rounded_qty = 300;}
			if(qty >= 500 && qty <= 999){rounded_qty = 500;}
			if(qty >= 1000 && qty <= 1999){rounded_qty = 1000;}
			if(qty >= 2000 && qty <= 2999){rounded_qty = 2000;}
			if(qty >= 3000 && qty <= 4999){rounded_qty = 3000;}
			if(qty >= 5000 && qty <= 9999){rounded_qty = 5000;}
			if(qty >= 10000){rounded_qty = 10000;}
				
			//GET ROUNDED SIZE
			if(typeof material_data.multipliers[rounded_qty][size_total] == 'undefined'){
				if(size_total > 0 && size_total < 2.5){rounded_size = 1;}
				if(size_total >= 2.5 && size_total < 8){rounded_size = 4;}
				if(size_total >= 8 && size_total <= 9){rounded_size = 9;}
				if(size_total > 9 && size_total <= 16){rounded_size = 16;}
				if(size_total > 16 && size_total < 100){rounded_size = 25;}
				if(size_total >= 100){rounded_size = 100;}
			}

			//CUSTOM QTY PREVIEW PRICE
			var multiplier = material_data.multipliers[rounded_qty][rounded_size],
				current_price = $.fn.getStickerPrice(size_total, qty, material_cost, multiplier);
			
			current_price = extra_multiplier ? current_price * extra_multiplier : current_price;
			current_price = current_price > 0 ? current_price : 10;
			
			$('#custom_qty_price').text(currency(current_price).format());
			$('#final_price').val(currency(current_price)).change();
			$('#final_custom_price').val(currency(current_price)).change();
			
			//SET PRODUCT PROPERTIES
			$('#properties_material').val(material_name);
			$('#properties_qty').val(qty);
			$('#properties_size').val(size_w+'x'+size_h);
		}

		let checkExist = setInterval(function () {
			if ($('#final_price').length) {
				$.fn.getFirstPrice();
				clearInterval(checkExist);
			}
		}, 500);
	
			//UPDATE SIZE INPUTS ON RADIO SIZE CLICK
		$(document).on('click', '.radio_size', function(event){
			var size_wxh = $(this).val();
		
			if(size_wxh == 'CustomSize'){
				$('#custom_size_inputs_wrappers').slideDown();
			}else{
				var size_wxh_arr = size_wxh.split('x'),
					size_w = size_wxh_arr[0],
					size_h = size_wxh_arr[1];
				
				$('#size_w').val(size_w).change();
				$('#size_h').val(size_h).change();
				$('#custom_size_inputs_wrappers').slideUp();
			}
		});
	
		//UPDATE QTY INPUT ON RADIO QTY CLICK
		$(document).on('click', '.radio_qty', function(event){
			var qty = $(this).val();
			
			if(qty == 'custom'){
				$('#custom_qty_inputs_wrappers').slideDown();
			}else{
				$('#custom_qty').val(qty).change();
				$('#custom_qty_inputs_wrappers').slideUp();
			}
		});
	
			//UPDATE PREVIEW PRICES ON MATERIAL CHANGE
		$(document).on('click', '.radio_material', function(event){
			$.fn.getPricesPreview();
		});

		//data-radio-multiplier
		$(document).on('click', '[data-radio-multiplier]', function(event){
			var multiplier = 1;
			
			$('[data-radio-multiplier]:checked').each(function(i, el){
				var this_val = parseFloat($(this).data('radio-multiplier'));
				multiplier += this_val;
			});
			
			$('#extra_multiplier').val(multiplier).change();
			
			$.fn.getPricesPreview();
		});

		if($('[data-radio-multiplier]').length > 0){
			$('[data-radio-multiplier]').first().click();
		}

		//data-show-white-ink-base
		$(document).on('click', '[data-show-white-ink-base]', function(event){
			var show = $(this).data('show-white-ink-base');
				
			if($('#extra_material_option').length > 0){
				if(show){
					$('#extra_material_option').show();
				}else{
					$('#extra_material_option').hide();
				}
			}
		});
	
		//FIX CUSTOM VALUE MULTIPLER OF 5 AND MINIMUN 10
		$(document).on('change', '#custom_qty', function(event){
			var input = $(this),
				custom_qty = $(input).val(),
				min = parseInt($(input).attr('min'));
			
			if(custom_qty < min) custom_qty = min

			custom_qty = parseInt(custom_qty);
			
			if(custom_qty % 5 != 0) custom_qty = Math.ceil(custom_qty / 5) * 5;
			
			$(input).val(custom_qty);
		});

		//size_w
		$(document).on('change', '.custom_size_input', function(event){
			var input = $(this),
				custom_qty = $(input).val(),
				min = parseInt($(input).attr('min'));
			
			if(custom_qty < min) custom_qty = min			
			$(input).val(custom_qty);
		});
		
		//UPDATE PREVIEW PRICES ON SIZE OR QTY CHANGE
		$(document).on('change', '#custom_qty, #size_w, #size_h', function(event){
			$.fn.getPricesPreview();
		});
	}
	
	/*** CART SIDEBAR ***/
	//add_stakes_form
	$(document).on('click', '.add_stakes_form #add_main_product', function(event){
		event.preventDefault();

		if($('#stakes_input').val() == 'yes'){
			var quantity = $('#option2').find(':selected').data('qty-value');
			
			fetch('https://www.stickerbros.com/cart/add?id=43710925865160&quantity='+quantity)
			.then(response => {
				$('.add_stakes_form').submit();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
		}else{
			$('.add_stakes_form').submit();
		}
	});
	
	//add_to_cart
	$(document).on('click', '#add_to_cart', function(event){
		if($('#final_add_to_cart').length){
			event.preventDefault();
			$('.uploadkit-button').click();
		} else if($('#uv_final_add_to_cart').length){
			event.preventDefault();
			$('.uploadkit-button').click();
		}
	});

	$(document).on('click', '.uploadcare--preview__done', function(event){
		if($('#final_add_to_cart').length){
			$('#cart_loader').addClass('loading');
			setTimeout(()=>{
				$('#final_add_to_cart').click();
			}, 1500);
		} else if($('#uv_final_add_to_cart').length){
			$('#cart_loader').addClass('loading');
			setTimeout(()=>{
				$('#uv_final_add_to_cart').click();
			}, 1500);
		}
	});
	
	$.fn.cartItem = function(item){
		var item_class = item.product_title;
			item_class = item_class.replace(' ', '-').replace(' ', '-');
		
		var image = item.properties && typeof item.properties['image_url'] != 'undefined' ? item.properties['image_url'] : item.image,
			html = '<div class="cart_item row align-items-center py-4 '+ item_class +'" data-item-id="'+ item.key +'">'+
				'<div class="col-2 px-1"><a href="'+ item.url +'"><img src="'+ image +'"></a></div>'+
				'<a href="'+ item.url +'" class="col-4 px-1">'+ item.product_title + ' <br>';
				
				if(typeof item.options_with_values[0] != 'undefined' && item.options_with_values[0].value != 'Default Title'){
					html += item.options_with_values[0].value;
				}

				if(typeof item.options_with_values[1] != 'undefined' && item.options_with_values[1].value != 'Default Title'){
					html += ' '+ item.options_with_values[1].value;
				}
				
				html += '</a>'+
				'<div class="col-2 px-2"><input type="number" name="qty" class="qty" value="'+ item.quantity +'" min="1" step="1"></div>'+
				'<div class="col-3 px-2 text-center"><span class="cart_item_price">'+ Shopify.formatMoney(item.original_line_price) +'</span></div>'+
				'<div class="col-1 px-2 d-flex align-items-center justify-content-center">'+
					'<span class="remove_cart_item"></span>'+
				'</div>'+
			'</div>';

		return html;
	}

	// uploadkit-form
	$(document).on('submit', '.deals_form', function(event){
		if($('#cart_body').find('.is_deal').length > 0){
			event.preventDefault();
			alert('It is only possible to buy this product once. It is already in your cart');
			return;
		}
		
		if($('.uploadkit-thumbnail').length > 0){
			var image = $('.uploadkit-thumbnail').attr('src');
			$('#properties_image_url').val(image).change();
		}
	});
	
	//ADD STICKER PRODUCT TO CART
	$(document).on('submit', '#sticker_product_form', function(event){
		event.preventDefault();
	
		var form_data = $('#sticker_product_form').serializeJSON(),
			add_data,
			properties = form_data.properties,
			url = 'https://api.icepick.co/stickerbros/create_product.php',
			try_again_url = 'https://api.icepick.co/stickerbros/get_variations.php';


		// Ensure core properties are present as line item properties
		properties = properties || {};
		var size_w_submit = parseFloat($('#size_w').val() || 0);
		var size_h_submit = parseFloat($('#size_h').val() || 0);
		if(size_w_submit){ properties['Width'] = size_w_submit; }
		if(size_h_submit){ properties['Height'] = size_h_submit; }
		var selected_qty_submit = parseInt($('#custom_qty').val() || $('.radio_qty:checked').val() || 0);
		if(!isNaN(selected_qty_submit) && selected_qty_submit > 0){ properties['Qty'] = selected_qty_submit; }
		var selected_material_submit = $('.radio_material:checked').val();
		if(selected_material_submit){ properties['Material'] = selected_material_submit; }

		if($('.uploadkit-thumbnail').length > 0){
			var image = $('.uploadkit-thumbnail').attr('src');
			properties['image_url'] = image;
		}
		
		// Resolve price to send (prefer hidden final_price)
		var priceToSend = form_data.final_price || form_data.uv_final_price || form_data.final_custom_price || form_data.uv_final_custom_price || $('#final_price').val() || $('#uv_final_price').val();

		$.ajax({
			url: url,
			type: 'post',
			data:{
				parent_id: form_data.product_id,
				price: priceToSend,
				properties: properties,
			},
			success: (response) => {
				try{
					response = typeof response === 'string' ? JSON.parse(response) : response;
				}catch(e){
					alert('Unexpected server response. Please try again.');
					return;
				}
				console.log(response);
				
				if(response.status == 'try_again'){
					alert('Please wait a moment, we are reviewing your order data.');

					setInterval(()=>{
						console.log('try again', response.random_id);
						
						$.ajax({
							url: try_again_url,
							type: 'post',
								data:{
									parent_id: form_data.product_id,
									uid: (response.random_id || response.uid)
								},
							success: (response) => {
								console.log(response);
								try{
									response = typeof response === 'string' ? JSON.parse(response) : response;
								}catch(e){
									return;
								}
								
								if(response.status == 'success'){
									add_data = {
										"items": [
											{
												id: response.data.variant.id,
												quantity: 1,
												properties: properties
											}
										]
									};
									
									$.post('/cart/add.js', add_data).then((response) => {
										window.location = '/cart';         
									});
								}
							}
						});
					}, 3000);
				}

				console.log(response, response.variant_id);
				
				if(response.status == 'success'){
					add_data = {
						"items": [
							{
								id: response.variant_id,
								quantity: 1,
								properties: properties
							}
						]
					};
					
					$.post('/cart/add.js', add_data).then((response) => {
						window.location = '/cart';         
					});
				}
			}
		});
	});

	//ADD UV STICKER PRODUCT TO CART
	$(document).on('submit', '#uv_sticker_product_form', function(event){
		event.preventDefault();

		var form_data = $('#uv_sticker_product_form').serializeJSON(),
			add_data,
			properties = form_data.properties,
			url = 'https://api.icepick.co/stickerbros/create_product.php',
			try_again_url = 'https://api.icepick.co/stickerbros/get_variations.php';


		// Ensure core properties for UV flow
		properties = properties || {};
		var uv_w_submit = parseFloat($('#uv_size_w').val() || 0);
		var uv_h_submit = parseFloat($('#uv_size_h').val() || 0);
		if(uv_w_submit){ properties['Width'] = uv_w_submit; }
		if(uv_h_submit){ properties['Height'] = uv_h_submit; }
		var uv_qty_submit = parseInt($('.uv_radio_qty:checked').val() || $('#uv_custom_qty').val() || 0);
		if(!isNaN(uv_qty_submit) && uv_qty_submit > 0){ properties['Qty'] = uv_qty_submit; }
		// Material is not part of UV flow unless exists as radio; keep if provided
		var uv_material_submit = $('.radio_material:checked').val();
		if(uv_material_submit){ properties['Material'] = uv_material_submit; }
		if($('.uploadkit-thumbnail').length > 0){
			var image = $('.uploadkit-thumbnail').attr('src');
			properties['image_url'] = image;
		}
		
		// Resolve price for UV submit as well
		var uvPriceToSend = form_data.final_price || form_data.uv_final_price || form_data.final_custom_price || form_data.uv_final_custom_price || $('#uv_final_price').val() || $('#final_price').val();

		$.ajax({
			url: url,
			type: 'post',
			data:{
				parent_id: form_data.product_id,
				price: uvPriceToSend,
				properties: properties,
			},
			success: (response) => {
				try{
					response = typeof response === 'string' ? JSON.parse(response) : response;
				}catch(e){
					alert('Unexpected server response. Please try again.');
					return;
				}
				console.log(response);
				
				if(response.status == 'try_again'){
					alert('Please wait a moment, we are reviewing your order data.');

					setInterval(()=>{
						$.ajax({
							url: try_again_url,
							type: 'post',
								data:{
									parent_id: form_data.product_id,
									uid: (response.random_id || response.uid)
								},
							success: (response) => {
								console.log(response);
								try{
									response = typeof response === 'string' ? JSON.parse(response) : response;
								}catch(e){
									return;
								}
								
								if(response.status == 'success'){
									add_data = {
										"items": [
											{
												id: response.data.variant.id,
												quantity: 1,
												properties: properties
											}
										]
									};
									
									$.post('/cart/add.js', add_data).then((response) => {
										window.location = '/cart';         
									});
								}
							}
						});
					}, 3000);
				}

				if(response.status == 'success'){
					add_data = {
						"items": [
							{
								id: response.variant_id,
								quantity: 1,
								properties: properties
							}
						]
					};
					
					$.post('/cart/add.js', add_data).then((response) => {
						window.location = '/cart';         
					});
				}
			}
		});
	});

	//data-reorder
	$(document).on('click', '[data-reorder]', function(event){
		const orderId = $(this).data('reorder');
		$.ajax({
			url: 'https://icepick.co/api/shopify/orders.php?order_id='+orderId,
			type: 'get',
			success: (data) =>{
				console.log(data);
				
				const obj = JSON.parse(data);

				if(obj.status == 'success'){
					add_data = {
							"items": obj.items
					};
					
					$.post('/cart/add.js', add_data).then((response) => {
							window.location = '/cart';
					});
				}
			}
		});
	});

	//data-add-product
	$(document).on('click', '[data-add-product]', function(event){
		var product_id = parseInt($(this).data('add-product'));      
		add_data = {
			"items": [
				{
					id: product_id,
					quantity: 1
				}
			]
		};

		 $.post('/cart/add.js', add_data).then((response) => {
			window.location = '/cart';
		});
	});

	//cart_trigger
	$(document).on('click', '#cart_trigger', function(event){
		$('body').addClass('cart_open');
	});

	//data-close-cart
	$(document).on('click', '[data-close-cart]', function(event){
		event.preventDefault();
		$('body').removeClass('cart_open');
	});

	$.fn.remove_cart_item = function(item_id){
		$('[data-item-id="'+ item_id +'"]').remove();
		
		$.ajax({
			url: window.Shopify.routes.root + 'cart/change.js',
			type: 'POST',
			data: {'id': item_id, 'quantity': 0},
			success: function(response) {
				var cart = jQuery.parseJSON(response);
				
				$('.subtotal_amount').text(Shopify.formatMoney(response.total_price));
				$('.grand_total_amount').text(Shopify.formatMoney(response.total_price));
				$('[data-cart-count]').text(cart.items.length);

				if (cart.items.length == 0) {
					$('#cart_sidebar_wrapper').addClass('cart_is_empty');
				}

				if($('#cart_body').find('#selected_rush_option').length > 0){
					var rush_item = $('#cart_body').find('#selected_rush_option').closest('.cart_item'),
						rush_id = $(rush_item).data('item-id');
					
					$.fn.remove_cart_item(rush_id);
				}else{
					$('.rush_option_accordeon').show();
				}
			}
		});
	}

	//remove_cart_item
	$(document).on('click', '[data-remove-cart-item]', function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).data('item-id');

		$.fn.remove_cart_item(id);
	});

	//sidebar_qty
	$(document).on('change', '.qty', function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).data('item-id'),
			qty = $(this).val(),
			min = parseInt($(this).attr('min'));

		if(!$(item).hasClass('sample-sticker-pack')){
			if(qty < min){
				$(this).val(min);
				qty = min;
			}
		}

		$('#cart_sidebar').addClass('loading');
			
		setTimeout(()=>{
			$('#cart_sidebar').removeClass('loading');

			if($('#cart_body').find('#selected_rush_option').length > 0){
				var rush_item = $('#cart_body').find('#selected_rush_option').closest('.cart_item'),
					rush_id = $(rush_item).data('item-id'),
					rush_option =$(rush_item).find('#selected_rush_option').val();
				
				$.fn.remove_cart_item(rush_id);
			}
		}, 2000);
				
		$.ajax({
			url: window.Shopify.routes.root + 'cart/change.js',
			type: 'POST',
			dataType: 'json',
			data: {'id': id,'quantity': qty},
			success: function(response) {
				var items_count = 0;
							
				$.each(response.items, function(i, item){
					items_count++;
				});
			
				$('.subtotal_amount').text(Shopify.formatMoney(response.total_price));
				$('.grand_total_amount').text(Shopify.formatMoney(response.total_price));
				$('[data-cart-count]').text(items_count);

				if(qty > 1){
					$(item).find('.orders_text').text('Orders');
				}else{
					$(item).find('.orders_text').text('Order');
				}
			
				if(response.item_count == 0){
					$('#cart_sidebar_wrapper').addClass('cart_is_empty');
				}
			}            
		});
	});

	//product_notes
	$(document).on('change', '.product_notes', function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).data('item-id'),
			notes = $(this).val();
		
		$.get(window.Shopify.routes.root + 'cart.js').then((response) => {
			var cart = jQuery.parseJSON(response),
				items = cart.items;
			
			var item = items.filter(function(item){
				return item.key == id;         
			});
			
			item[0].properties.Notes = notes;
			
			$.post(window.Shopify.routes.root + 'cart/change.js', {'id': id, 'properties': item[0].properties}).then((response) => {
				var cart = jQuery.parseJSON(response);
			});
		});
	});

	/*** WHOLESALE AND BANNER PRODUCTS ***/
	if($('.wholesale_qty').length > 0){
		var qty = $('[data-select-option="quantity"]').val(),
			prev_price = $('#prev_price').val(),
			price = currency(prev_price).multiply(qty);

		if(price.value){
			$('#total_line').show();
			$('#total').text(currency(price).format());
		}else{
			$('#total_line').hide();
		}
	}

	//option_selection
	$(document).on('change', '.option_selection', function(event){
		var selected_options = [],
			this_val = $(this).val(),
			qty = $('.wholesale_qty').val(),
			product_id = $('form[data-product-id]').data('product-id');

		$('.option_selection').each(function(el, selector) {
			var selected = $(this).val();
			selected_options.push(selected);
		});
		
		var selected_variation = $.grep(variations, function(variation) {
			return variation.options.toString() === selected_options.toString();
		});

		if(selected_variation.length){
			$('#product_id').val(selected_variation[0].id);
			$('#product_price').text(Shopify.formatMoney(selected_variation[0].price));

			$('#total').text(Shopify.formatMoney(selected_variation[0].price * qty));

			if($('#prev_price').length > 0){
				$('#prev_price').val(Shopify.formatMoney(selected_variation[0].price));
			}
		
			if(selected_variation[0].featured_image){
				$('#product_main_image').attr('src', selected_variation[0].featured_image.src);
			}
		}else{

			if(product_id == '8218867007688'){
				selected_options[2] = 'Default';
				
				console.log(variations);
				console.log(selected_options);

				//GET BASE PRICE
				var price_selected_variation = $.grep(variations, function(variation) {
					return variation.options.toString() === selected_options.toString();
				});

				console.log(price_selected_variation);
	
				$('#product_price').text(Shopify.formatMoney(price_selected_variation[0].price));
				
				if($('#prev_price').length > 0){
					$('#prev_price').val(Shopify.formatMoney(price_selected_variation[0].price));
				}
			}else{
				$('#product_id').val(0);
	
				selected_options[2] = 'Standard Emboss';
				
				//GET BASE PRICE
				var price_selected_variation = $.grep(variations, function(variation) {
					return variation.options.toString() === selected_options.toString();
				});
	
				$('#product_price').text(Shopify.formatMoney(price_selected_variation[0].price));
				
				if($('#prev_price').length > 0){
					$('#prev_price').val(Shopify.formatMoney(price_selected_variation[0].price));
				}
			}
		}

		var price_multiplier_var = $(this).data('select-option');

		if($('[data-price-multiplier-select="'+ price_multiplier_var +'"]').length){
			$('[data-price-multiplier-select="'+ price_multiplier_var +'"]').val(this_val).change();          
		}
	});

	//data-select-option
	$(document).on('change', '[data-select-option="print-ready-file"]', function(event){
		var v = $(this).val();
		
		if(v == 'I have a print ready file'){
			$('#optional_upload_file').slideDown();
		}else{
			$('#optional_upload_file').slideUp();
		}
	});

	if($('[data-select-option="print-ready-file"]').length > 0){
		var v = $('[data-select-option="print-ready-file"]').val();
		
		if(v == 'I have a print ready file'){
			$('#optional_upload_file').show();
		}else{
			$('#optional_upload_file').hide();
		}
	}

	//data-select-option="sides"
	$(document).on('change', '[data-select-option="sides"]', function(event){
		var v = $(this).val();
			
		if(v == 'Double Sided'){
			$('[data-uploader-id="166d0f96-7b67-4774-9c3a-663d159305a9"]').show();
		}else{
			$('[data-uploader-id="166d0f96-7b67-4774-9c3a-663d159305a9"]').hide();
		}
	});

	//WHOLE SALE BUNDLE PRICE
	$(document).on('change', '.wholesale_qty', function(event){
		if($('[data-select-option="bundle-price"]').length > 0){
			var v = $(this).val(),
				bundle = v >= 6 ? '6+' : '1-5';
			
			$('[data-select-option="bundle-price"]').val(bundle).change();
		}

		var qty = parseInt($(this).val()),
			prev_price = $('#prev_price').val(),
			extra_fee = $('#extra_fee').val(),
			price = currency(prev_price).multiply(qty).add(extra_fee),
			min = parseInt($('.wholesale_qty').attr('min'));

		if(price.value){
			$('#total_line').show();
			$('#total').text(currency(price).format());
		}else{
			$('#total_line').hide();
		}

		// Minimum quantity
		if(qty < min) $(this).val(min);
	});

	$(document).on('change', '[data-select-option="quantity"]', function(event){
		var qty = $(this).find(':selected').data('qty-value');
		$('.wholesale_qty').val(qty).change();
	});

	if($('.icepick_wholesale').length > 0 && $('#option1').length){
		$('.wholesale_qty').trigger('change');
	}
	
	if($('#wholesale_material_options').length){
		var materials = $('#wholesale_material_options').data('materials'),
			html = '';
		
		$.each(materials, (option, values) => {
			html += '<div class="d-none">'+
						'<select name="properties['+option+']" data-price-multiplier-select="'+ option.toLowerCase() +'">';

						$.each(values, (key, value) => {
							html += '<option value="'+ key +'" data-price-multiplier="'+ value +'">'+ key +'</option>';
						});

			html += '</select></div><input type="hidden" id="price_multiplier" name="price_multiplier" value="0">';
		});

		$('#wholesale_material_options').html(html);
	}

	//data-price-multiplier
	$(document).on('change', '[data-price-multiplier-select]', function(event){
		var multiplier = $(this).find(':selected').data('price-multiplier'),
			price = $('#prev_price').val();

		$('#price_multiplier').val(multiplier).change();

		price = currency(price).multiply(multiplier).format();

		$('#product_price').text(price);
	});
	
	//api_form
	$(document).on('submit', '.api_form', function(event){
		if($('#product_id').val() == 0){
			event.preventDefault();
			
			var form_data = $(this).serializeJSON(),
				now = Date.now();

			$.ajax({
				url: 'https://icepick.co/api/shopify/wholesale.php?v='+ now,
				type: 'post',
				data:{
					form_data: form_data
				},
				success: (data) => {
					const obj = JSON.parse(data);
					$('#product_id').val(obj.variant.id);
				}
			});  
		}
	});

	//CUSTOM PRICING FORM
	function updateTotalCustomPricing() {
		var qty = parseInt($('input[name="quantity"]').val()) || 0;
		var unit = parseFloat(($('input[name="prev_price"]').val() || "0").replace(/[^0-9.]/g, ''));
		var extra = parseFloat($('input[name="extra_fee"]').val() || 0);
		var total = (qty * unit) + extra;

		$('#total').text('$' + total.toFixed(2));
		// Actualiza el campo oculto final_price si existe
		if($('input[name="final_price"]').length){
			$('input[name="final_price"]').val(total.toFixed(2));
		}
	}

	$(document).on('input change', '.custom_pricing_form input[name="quantity"], .custom_pricing_form input[name="prev_price"], .custom_pricing_form input[name="extra_fee"], .custom_pricing_form .option_selection', updateTotalCustomPricing);
	$(document).ready(updateTotalCustomPricing);

	function generateRandomString(length) {
		var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		var result = '';
		for (var i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	}

	$(document).on('submit', '.custom_pricing_form', function(event){
		event.preventDefault();
		var form = $(this);
		var form_data = form.serializeJSON(),
			now = Date.now();

		// Calcula y asegura que los campos prev_price y final_price estén correctos
		var qty = parseInt(form_data.quantity) || 0;
		var unit = parseFloat((form_data.prev_price || "0").replace(/[^0-9.]/g, ''));
		var extra = parseFloat(form_data.extra_fee || 0);
		var total = (qty * unit) + extra;
		form_data.prev_price = unit.toFixed(2);
		form_data.final_price = total.toFixed(2);

		// Asignar un valor random a option3 (Design) si no existe
		if(!form_data.option3){
			form_data.option3 = generateRandomString(12);
		}

		// Si option3 es 'Default', usar flujo estándar de Shopify
		if(form_data.option3 === 'Default'){
			// Puedes usar el submit normal del form o un POST a /cart/add.js
			// Aquí usamos POST a /cart/add.js para mantener el flujo AJAX
			var shopifyData = {
				id: form_data.id || form_data["product_id"] || form_data["product-id"],
				quantity: 1, // Siempre 1
				properties: {
					"Quantity": qty
				}
			};
			$.post('/cart/add.js', shopifyData)
				.done(function(response){
					window.location = '/cart';
				})
				.fail(function(){
					alert('Error adding product to cart.');
				});
			return;
		}

		// Si option3 es custom, usar la API custom
		$.ajax({
			url: 'https://api.icepick.co/shopify/custompricing.php?v='+ now,
			type: 'post',
			data:{
				form_data: form_data
			},
			success: (data) => {
				let obj;
				try {
					obj = JSON.parse(data);
				} catch (e) {
					alert('Unexpected server response. Please try again.');
					return;
				}
				// Mostrar logs de debug si existen
				if(obj.debug && Array.isArray(obj.debug)){
					console.log('DEBUG LOGS:', obj.debug);
				}
				if(obj.status === 'default_variant'){
					// Respaldo: si la API responde que es default, usar flujo estándar
					var shopifyData = {
						id: form_data.id || form_data["product_id"] || form_data["product-id"],
						quantity: 1, // Siempre 1
						properties: {
							"Quantity": qty
						}
					};
					$.post('/cart/add.js', shopifyData)
						.done(function(response){
							window.location = '/cart';
						})
						.fail(function(){
							alert('Error adding product to cart.');
						});
					return;
				}
				if(obj.variant && obj.variant.id){
					$('#product_id').val(obj.variant.id);
					// Agregar la nueva variante custom al carrito
					var add_data = {
						items: [
							{
								id: obj.variant.id,
								quantity: 1, // Siempre 1
								properties: {
									"Quantity": qty
								}
							}
						]
					};
					$.post('/cart/add.js', add_data).then(function(){
						window.location = '/cart';
					});
				} else if(obj.error){
					alert('Error: ' + obj.error);
				} else {
					alert('Unexpected error. Please try again.');
				}
			},
			error: function(xhr) {
				let msg = 'Server error. Please try again.';
				if(xhr.responseText){
					try {
						const obj = JSON.parse(xhr.responseText);
						// Mostrar logs de debug si existen
						if(obj.debug && Array.isArray(obj.debug)){
							console.log('DEBUG LOGS:', obj.debug);
						}
						if(obj.error) msg = obj.error;
					} catch(e){}
				}
				alert(msg);
			}
		});  
	});

	//data-open-deals-lightbox
	$(document).on('click', '[data-open-deals-lightbox]', function(event){
		event.preventDefault();
		$('#confirmation_lightbox').addClass('open_lightbox');
	});
	
	//data-form-onetimedeal
	$(document).on('submit', '#onetimedeal_form', function(event){
		event.preventDefault();
			
		var form = $(this),
			email = $(form).find('[name="account_email"]').val(),
			product = $(form).find('[name="product_id"]').val();
			
		$.ajax({
			url: 'https://icepick.co/api/shopify/onetimedeal.php',
			type: 'POST',
			data:{
				email: email,
				product: product
			},
			beforeSend: function(){
				$(form).addClass('loading');
			},
			success: function(data){
				$(form).removeClass('loading');
				data = JSON.parse(data);

				if(data.status == 'error'){
					alert('Unexpected error. Please try again later');
				}

				if(data.status == 'already_purchased'){
					$('#onetimedeal_form').hide();
					$('#onetimedeal_already_purchased').show();
				}

				if(data.status == 'success'){
					$('#onetimedeal_form').hide();
					$('#onetimedeal_product_form').show();
				}
			}
		});
	});

	//mobile_has_children
	$(document).on('click', '.mobile_has_children', function(event){
		event.preventDefault();

		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$(this).next('.mobile_submenu').slideUp();
		}else{
			$(this).addClass('open');
			$(this).next('.mobile_submenu').slideDown();
		}
	});

	//data-open-chat
	$(document).on('click', '[data-open-chat]', function(event){
		event.preventDefault();
		document.querySelector("#dummy-chat-button-iframe").contentWindow.document.querySelector('.chat-toggle').click();
	});

	//rush_option_header
	$(document).on('click', '.rush_option_header', function(event){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('.rush_option_body').slideUp();
		}else{
			$(this).addClass('open');
			$('.rush_option_body').slideDown();
		}
	});

	//rush_option
	$.fn.addRushOption = function(rush_option){
		if(rush_option == 'standard') return;
		
		var items = $('.cart_item:not(.product_rush-option)'),
				subtotal = 0,
				now = Date.now();

		$.each(items, function(idx, item){
			var price = $(item).find('.discounted_price').lenght > 0 ? $(item).find('.discounted_price').text() : $(item).find('.original_price').text();
			subtotal = currency(subtotal).add(price).value;
		});
		
		if(!subtotal) return;

		$.ajax({
			url: 'https://icepick.co/api/shopify/rushoption.php?v='+ now,
			type: 'post',
			data:{
				subtotal: subtotal,
				rush_option: rush_option
			},
			beforeSend: () =>{
				$('#cart_sidebar').addClass('loading');
			},
			success: (data) =>{
				$('#cart_sidebar').removeClass('loading');
				
				const obj = JSON.parse(data);
				
				if(obj.status != 'success'){
					if(obj.error){
						alert(obj.error);
						return;
					}else{
						alert('An unexpected error occurred, please verify your data and try again');
						return;
					}
				}
				
				$.each(obj.items, function(index, element) {
					if(element.id === 0 || element.id == null) {
						obj.items.splice(index, 1);
					}
				});
				
				add_data = {
					"items": obj.items
				};

				var cart_total = 0;
				
				$.post('/cart/add.js', add_data).then((response) => {
					var added_item = JSON.parse(response).items[0];
					var obj_html = '<div class="cart_item row py-4 align-items-start product_rush-option product_rush-option" data-item-id="'+ added_item.key +'">'+
										'<div class="col-12">'+
											'<div class="row">'+
												'<div class="col-8">'+
													'<span class="cart_item_title d-block">Rush Option</span>'+
													'<ul class="cart_item_attr">'+
														'<li>Production time:<br>'+ added_item.properties.RushOption +'</li>'+
														'<input type="hidden" id="selected_rush_option" value="'+ added_item.properties.nude_rushoption +'">'+
													'</ul>'+
												'</div>'+
												'<div class="col-4 text-end"><span class="hulkapps-cart-item-line-price" data-key="'+ added_item.key +'"><span class="original_price">'+ Shopify.formatMoney(added_item.final_price) +'</span></span></div>'+
											'</div>'+
											'<div class="row">'+
												'<div class="col-8"></div>'+
												'<div class="col-4">'+
													'<span class="cart_item_remove d-block text-end" data-remove-cart-item="">Remove</span>'+
												'</div>'+
											'</div>'+
										'</div>'+
									'</div>';
					
					$('#cart_body').append(obj_html);

					$('.rush_option_accordeon').hide();
					$('.rush_option_body').hide();
					$('.rush_option_header').removeClass('open');
					
					setTimeout(()=>{
						$.getJSON('/cart.js', function(cart) {
							cart_total = cart.total_price;
							$('.subtotal_amount').text(Shopify.formatMoney(cart_total));
							$('.grand_total_amount').text(Shopify.formatMoney(cart_total));
						});
					}, 500);
				});
			}
		});
	}

	//CLICK RUSH OPTION RADIOS
	$(document).on('click', '.rush_option', function(event){
		var rush_option = $(this).val();
		$.fn.addRushOption(rush_option);
	});

	$.fn.addRushOptionClick = function(option){
		$('[value="'+ option +'"]').click();
	}

	if($('.cart_is_empty').length){
		$.getJSON('/cart.js', function(cart) {
			var cart_total = cart.total_price;
			if(cart_total){
				localStorage.setItem('stickerbors_lpv', 'cart');
				location.reload();
			}
		});
	}

	//acordion_header
	$('.acordion_header').on('click', function(){
		var item = $(this).closest('.acordion_item'),
			content = item.find('.acordion_body');
		
		if($(item).hasClass('open')){
			$(item).removeClass('open');
			content.slideUp();
		}else{
			$('.acordion_item').removeClass('open');
			$('.acordion_body').slideUp();
			
			item.addClass('open');
			content.slideDown();
		}
	});

	/*** SPECIAL CASES ***/
	if($('#product_form_8218867007688').length > 0){
		var finish = $('[data-select-option="finish"]').val();
		var extra_fee = finish == 'Spot Gloss' || finish == 'HD Embossing' ? 10 : 0;
		
		$(document).on('change', '[data-select-option="finish"]', function(event){
			finish = $('[data-select-option="finish"]').val();
			extra_fee = finish == 'Spot Gloss' || finish == 'HD Embossing' ? 10 : 0;
			$('#extra_fee').val(extra_fee).change();
			$('#extra_fee_line').toggle(extra_fee > 0);

			if(extra_fee > 0){
				$('#option3').val(Math.random().toString(36).substring(2, 15));
			}else{
				$('#option3').val('Default');
			}
		});
	}

	/**** UV STICKERS PRICING SYSTEM ****/
	if($('#uv_sticker_product_form').length > 0){
		// UV Stickers pricing function - corrected interpretation
		$.fn.getUVStickerPrice = function(width, height, quantity) {
			const sqIn = width * height;
			let baseRate;

			// Base Rate by Size (Square Inches)
			if (sqIn <= 4) baseRate = 0.21;
			else if (sqIn <= 9) baseRate = 0.17;
			else if (sqIn <= 16) baseRate = 0.12;
			else if (sqIn <= 36) baseRate = 0.090; 
			else if (sqIn <= 64) baseRate = 0.065;
			else if (sqIn <= 93.5) baseRate = 0.065;
			else baseRate = 0.060;

			// Quantity Discount Tiers
			let discountMultiplier;
			if (quantity < 15) discountMultiplier = 1.05;
			else if (quantity < 25) discountMultiplier = 1.29;
			else if (quantity < 50) discountMultiplier = 1.15;
			else if (quantity < 100) discountMultiplier = 0.89;
			else if (quantity < 200) discountMultiplier = 0.80;
			else if (quantity < 300) discountMultiplier = 0.78;
			else if (quantity < 500) discountMultiplier = 0.72;
			else discountMultiplier = 0.50;
	

			// Calculate price per unit first, then multiply by quantity
			// Formula: (Width x Height) x Base Rate x Quantity Discount x 1 = Price per Unit
			const pricePerUnit = sqIn * baseRate * discountMultiplier * 1;
			const totalPrice = pricePerUnit * quantity;

			// Round to nearest whole dollar
			return Math.round(totalPrice);
		}

		// Get UV Stickers price previews for different quantities
		$.fn.getUVPricesPreview = function(){
			var qty = parseInt($('.uv_radio_qty:checked').val()) || parseInt($('#uv_custom_qty').val());
			// Get size from selected radio or custom inputs
			var selected_size = $('.uv_radio_size:checked').val();
			var size_w, size_h;
			
			if(selected_size && selected_size !== 'CustomSize') {
				var size_parts = selected_size.split('x');
				size_w = parseFloat(size_parts[0]) || 2;
				size_h = parseFloat(size_parts[1]) || 2;
			} else {
				size_w = parseFloat($('#uv_size_w').val()) || 2;
				size_h = parseFloat($('#uv_size_h').val()) || 2;
			}

			// Validate inputs
			if(!size_w || !size_h || !qty || size_w <= 0 || size_h <= 0 || qty <= 0) {
				return;
			}

			// Calculate current price
			var current_price = $.fn.getUVStickerPrice(size_w, size_h, qty);
			
			// Update price displays
			$('#uv_custom_qty_price').text('$' + current_price);
			$('#uv_final_price').val(current_price).change();
			$('#uv_final_custom_price').val(current_price).change();
			$('#uv_display_price').text('$' + current_price);

			// Update product properties
			$('#uv_properties_qty').val(qty);
			$('#uv_properties_size').val(size_w + 'x' + size_h);
			
			// Update quantity preview prices
			$('[data-uv-qty-preview]').each(function(idx, item){
				var item_qty = parseInt($(this).data('uv-qty-preview')),
					preview_price = $.fn.getUVStickerPrice(size_w, size_h, item_qty);
				$(item).text('$' + preview_price);
			});
		}

		// Initialize first price calculation
		$.fn.getUVFirstPrice = function(){
			var qty = parseInt($('.uv_radio_qty:checked').val()) || parseInt($('#uv_custom_qty').val()) || 10;
			
			// Get size from selected radio or custom inputs
			var selected_size = $('.uv_radio_size:checked').val();
			var size_w, size_h;
			
			if(selected_size && selected_size !== 'CustomSize') {
				var size_parts = selected_size.split('x');
				size_w = parseFloat(size_parts[0]) || 2;
				size_h = parseFloat(size_parts[1]) || 2;
			} else {
				size_w = parseFloat($('#uv_size_w').val()) || 2;
				size_h = parseFloat($('#uv_size_h').val()) || 2;
			}

			var current_price = $.fn.getUVStickerPrice(size_w, size_h, qty);
			
			$('#uv_custom_qty_price').text('$' + current_price);
			$('#uv_final_price').val(current_price).change();
			$('#uv_final_custom_price').val(current_price).change();
			$('#uv_display_price').text('$' + current_price);
			
			// Set product properties
			$('#uv_properties_qty').val(qty);
			$('#uv_properties_size').val(size_w + 'x' + size_h);
		}

		// Initialize UV pricing when elements are ready
		let uvCheckExist = setInterval(function () {
			if ($('#uv_final_price').length) {
				$.fn.getUVFirstPrice();
				clearInterval(uvCheckExist);
				
				// Auto-trigger price calculation after 1 second to show default prices
				setTimeout(function() {
					$('.uv_radio_size:first').trigger('click');
					$.fn.getUVPricesPreview();
				}, 1000);
			}
		}, 500);

		// Event Listeners for UV Stickers

		// Size radio button change
		$(document).on('click', '.uv_radio_size', function(event){
			var size_wxh = $(this).val();
			
			if(size_wxh == 'CustomSize'){
				$('#uv_custom_size_inputs_wrapper').slideDown();
			}else{
				var size_wxh_arr = size_wxh.split('x'),
					size_w = size_wxh_arr[0],
					size_h = size_wxh_arr[1];
				
				$('#uv_size_w').val(size_w).change();
				$('#uv_size_h').val(size_h).change();
				$('#uv_custom_size_inputs_wrapper').slideUp();
			}
			
			// Update prices when size changes
			$.fn.getUVPricesPreview();
		});

		// Quantity radio button change
		$(document).on('click', '.uv_radio_qty', function(event){
			var qty = $(this).val();
			
			if(qty == 'custom'){
				$('#uv_custom_qty_wrapper').slideDown();
			}else{
				$('#uv_custom_qty').val(qty).change();
				$('#uv_custom_qty_wrapper').slideUp();
			}
			
			// Update prices when quantity changes
			$.fn.getUVPricesPreview();
		});

		// Custom quantity validation (minimum 1, step 1)
		$(document).on('change', '#uv_custom_qty', function(event){
			var input = $(this),
				custom_qty = parseInt($(input).val()),
				min = parseInt($(input).attr('min')) || 1;
			
			if(custom_qty < min || isNaN(custom_qty)) {
				custom_qty = min;
			}
			
			$(input).val(custom_qty);
		});

		// Size input validation
		$(document).on('change', '.uv_custom_size_input', function(event){
			var input = $(this),
				custom_size = parseFloat($(input).val()),
				min = parseFloat($(input).attr('min')) || 0.5;
			
			if(custom_size < min || isNaN(custom_size)) {
				custom_size = min;
			}
			
			$(input).val(custom_size);
		});
		
		// Update prices on any input change
		$(document).on('change', '#uv_custom_qty, #uv_size_w, #uv_size_h', function(event){
			$.fn.getUVPricesPreview();
		});
	}
});